'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import Immutable from 'immutable';
import text from 'I18n/utils/unescapedText';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import { getCategoryMenuOptions } from '../utils/sidebarUtils';
import { getNameAndSidebarFilterOptions, getTrimmedSearchTerm, isSidebarFilterType } from '../utils/searchBarUtils';
import { requestStatusPropType } from '../constants/propTypes/requestStatus';
import { isUninitialized } from '../utils/requestStatus';
export default createReactClass({
  displayName: "SearchBar",
  propTypes: {
    allProviders: PropTypes.array.isRequired,
    appliedSearchTerm: PropTypes.string.isRequired,
    autocomplete: PropTypes.instanceOf(Immutable.Map).isRequired,
    categoryFilter: PropTypes.string.isRequired,
    debouncedFetchForAutocomplete: PropTypes.func.isRequired,
    fetchProviders: PropTypes.func.isRequired,
    goodFilters: PropTypes.instanceOf(Immutable.Map).isRequired,
    onFilterByNameSelection: PropTypes.func.isRequired,
    onGoodSelection: PropTypes.func.isRequired,
    onSidebarFilterSelection: PropTypes.func.isRequired,
    providersRequestStatus: requestStatusPropType.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      searchTerm: this.props.appliedSearchTerm
    };
  },
  handleInputChange: function handleInputChange(event) {
    var _this$props = this.props,
        debouncedFetchForAutocomplete = _this$props.debouncedFetchForAutocomplete,
        onFilterByNameSelection = _this$props.onFilterByNameSelection;
    this.setState({
      searchTerm: event.target.value
    });
    var trimmedSearchTerm = getTrimmedSearchTerm(event.target.value);

    if (trimmedSearchTerm === '') {
      onFilterByNameSelection(trimmedSearchTerm);
    } else {
      debouncedFetchForAutocomplete(trimmedSearchTerm);
    }
  },
  handleInputFocus: function handleInputFocus() {
    var _this$props2 = this.props,
        fetchProviders = _this$props2.fetchProviders,
        providersRequestStatus = _this$props2.providersRequestStatus;

    if (isUninitialized(providersRequestStatus)) {
      fetchProviders();
    }
  },
  handleOptionSelection: function handleOptionSelection(event) {
    var selectedValue = event.target.value;

    if (this.isSpecificGoodSelected(selectedValue)) {
      this.props.onGoodSelection(selectedValue);
      return;
    }

    if (isSidebarFilterType(selectedValue)) {
      this.setState({
        searchTerm: ''
      });
      this.props.onSidebarFilterSelection(selectedValue);
      return;
    }

    this.setState({
      searchTerm: selectedValue
    });
    this.props.onFilterByNameSelection(getTrimmedSearchTerm(selectedValue));
  },
  isSpecificGoodSelected: function isSpecificGoodSelected(selectedValue) {
    return this.props.autocomplete.getIn(['resultsIndex', selectedValue]);
  },
  getPlaceholder: function getPlaceholder() {
    var categoryFilter = this.props.categoryFilter;

    if (!categoryFilter || categoryFilter === 'all-products') {
      return text('header.searchPlaceholder.ALL');
    } else {
      var filterCategory = getCategoryMenuOptions(categoryFilter).parent;
      return text("header.searchPlaceholder." + filterCategory);
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        allProviders = _this$props3.allProviders,
        appliedSearchTerm = _this$props3.appliedSearchTerm,
        autocomplete = _this$props3.autocomplete,
        goodFilters = _this$props3.goodFilters;
    var suggestedFilters = getNameAndSidebarFilterOptions(this.state.searchTerm, goodFilters, allProviders, autocomplete.get('resultsToDisplay').size);
    return React.createElement(UITypeahead, {
      autoFilter: false,
      className: "search-bar-and-results",
      hideResults: !autocomplete.get('showMenu') || !this.state.searchTerm && !appliedSearchTerm,
      onChange: this.handleOptionSelection,
      onFocus: this.handleInputFocus,
      onSearchChange: this.handleInputChange,
      options: [{
        options: suggestedFilters.toJS(),
        text: text('MarketplaceUI.searchBar.suggestedFiltersText')
      }, {
        options: autocomplete.get('resultsToDisplay').toJS(),
        text: text('MarketplaceUI.searchBar.displayedResultsText')
      }],
      search: this.state.searchTerm,
      resultsClassName: "search-results",
      searchClassName: "search-bar",
      placeholder: this.getPlaceholder()
    });
  }
});